import { AvailableAgents } from '../constants/AvailableAgents.js';
export const mapChatSourceFromAgentId = (agentId) => {
    const agent = AvailableAgents.find(agent => agent.agentId === agentId);
    return agent ? agent.chatSource : '';
};
//# sourceMappingURL=mapChatSourceFromAgentId.js.map